import { forwardRef, HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const DropdownFooter = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    className={cn(
      'absolute bottom-0 left-0 w-full border-t border-gray-200 px-2 py-1 text-sm font-medium text-gray-400',
      className
    )}
    ref={ref}
    {...props}
  />
))
